import React from 'react';
import overrideStyle from 'lib/overrideStyle';
import { keyframes } from 'styled-components';

export default function LoadingSpinner() {
  return (
    <Spinner>
      <Rotate delay={0} />
      <Rotate delay={1} />
      <Rotate delay={2} />
      <Rotate delay={3} />
    </Spinner>
  );
}

const Spinner = overrideStyle('div')`
  align-items: center;
  display: flex;
  height: 75%;
  justify-content: center;
  position: relative;
  width: 100%;
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Rotate = overrideStyle('div')`
  animation: ${rotate} 1.2s linear infinite;
  border: 3px solid #A8A8A8;
  border-color: #A8A8A8 transparent transparent transparent;
  border-radius: 50%;
  box-sizing: border-box;
  display: block;
  height: 51px;
  margin: 6px;
  position: absolute;
  width: 51px;
  animation-delay: ${p => {
    switch (p.delay) {
      case 1:
        return '-0.45s';
      case 2:
        return '-0.3s';
      case 3:
        return '-0.15s';
      default:
        return '0s';
    }
  }};
`;
